var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-grid',{attrs:{"url":"campaignPortalVisits","baseUrl":"https://dinner-compaign.azurewebsites.net","columns":_vm.columns,"title":_vm.title,"sortOptions":{
        enabled: true,
        field: 'timestamp',
        type: 'desc'
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }